import { render, staticRenderFns } from "./DotIndicator.vue?vue&type=template&id=482323d8&scoped=true&"
import script from "./DotIndicator.vue?vue&type=script&lang=js&"
export * from "./DotIndicator.vue?vue&type=script&lang=js&"
import style0 from "./DotIndicator.vue?vue&type=style&index=0&id=482323d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482323d8",
  null
  
)

export default component.exports